import { Form, IFormContext } from 'rewire-ui';

export class AreaSettingsDialogAdvancedViewModel {
  form:    Form;
  areaId?: string;

  constructor() {
    this.form = Form.create((form: IFormContext) => ({
      areaName   : form.static().label('Area'),
      setting1   : form.boolean().label('Setting1').autoFocus(),
      setting2   : form.boolean().label('Setting2'),
      timeToParty: form.time().label('Time To Party').validators('required').placeholder('When should we party?'),
    }), {}, {updateOnChange: true});
  }

  reset() {
    this.form.reset();
    this.areaId = undefined;
  }

  load(areaId: string) {
    this.reset();
    this.areaId = areaId;
  }

  get isDisabled(): boolean {
    return !this.form.hasChanges;
  }

  submit = async () => {
    if (this.isDisabled || !this.form.submit()) return false;

    this.form.revert();
    return true;
  };
}

const areaSettingsDialogAdvancedViewModel = new AreaSettingsDialogAdvancedViewModel();
export default areaSettingsDialogAdvancedViewModel;
